// @ts-nocheck

import { createAction, createSlice } from '@reduxjs/toolkit';
import { roleApi } from './../lib/api';
import type { Role } from '../lib/types';
const SET_ROLE = '/vehicles/role/set';
const CLEAN_ROLE = '/vehicles/role/clean';
const initialState = null as Role | null;
const setRoleAction = createAction<Role>(SET_ROLE);
const cleanRoleAction = createAction(CLEAN_ROLE);
const roleSlice = createSlice({
  name: 'role',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(setRoleAction, (state, {
      payload
    }) => ({
      ...payload
    })).addCase(cleanRoleAction, () => null);
  }
});
export const roleActions = {
  set: setRoleAction,
  clean: cleanRoleAction
};
export const addRole = role => async dispatch => {
  const payload = await roleApi.addRole(role);
  dispatch(roleActions.set(payload));
};
export const updateRole = role => async (dispatch, getState) => await roleApi.updateRole(role);

// Удаление роли
export const deleteRole = id => async dispatch => await roleApi.deleteRole(id);

// Подгрузка конкретной роли
export const fetchRole = id => async dispatch => {
  let role = await roleApi.fetchRole(id);
  dispatch(roleActions.set({
    ...role
  }));
};
export const cleanRole = () => dispatch => {
  dispatch(roleActions.clean());
};
export default roleSlice.reducer;
